import ContentSections from "../../ContentSections/ContentSections";

export default function Apresentacao({ sections }) {
  return (
    <ContentSections
      sections={sections}
      className="content-sections--intro"
      emptyMessage="Em breve, a apresentação deste núcleo será exibida aqui."
    />
  );
}
